module.exports = __webpack_public_path__ + "static/pauserecording1-4856bda358e641489db84887b8ac823b.png";